// Auto-generated normalizer for table: NivelesJerarquicos
export function nivelJerarquicoNormalize(row) {
  return {
    idNivelJerarquico: row.idNivelJerarquico ?? row.IdNivelJerarquico ?? row["idNivelJerarquico"] ?? row["IdNivelJerarquico"] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row["nombre"] ?? row["Nombre"] ?? "",
    descripcion: row.descripcion ?? row.Descripcion ?? row["descripcion"] ?? row["Descripcion"] ?? "",
    idEmpresa: row.idEmpresa ?? row.IdEmpresa ?? row["idEmpresa"] ?? row["IdEmpresa"] ?? null,
    nombreEmpresa: row.nombreEmpresa ?? row.NombreEmpresa ?? row["nombreEmpresa"] ?? row["NombreEmpresa"] ?? "",
    activo: row.activo ?? row.Activo ?? row["activo"] ?? row["Activo"] ?? true,
  };
}
